import React, { useContext, useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { IoIosAddCircle } from "react-icons/io";
import {
  AddQnA,
  QuestionList,
  UpdateQnA,
  UserQuestion,
} from "../../api/FetchAPI";
import { AuthContext } from "../AuthContextComponent";
import {
  QnARequestArray,
  UpdateQnARequestArray,
} from "../../lib/interfaces/AddQnAInterface";
import { SecurityQuestionRequestArray } from "../../lib/interfaces/SecurityQuestion";
import { ALERTMSG } from "../../lib/enums/AlertMsgs";
import {
  confirmationMsg,
  generateLoading,
  showAlert,
  showConnectionError,
  stopLoading,
} from "../../promptMessages/PromptMessages";
import { isAxiosError } from "axios";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import useUserLogin from "../../hooks/UserLoginhook";
type ButtonHoverStates = {
  [key: string]: {
    edit: boolean;
    delete: boolean;
  };
};

const DynamicTable: React.FC<any> = (props: any) => {
  const { setIsDone } = props;
  const { username, userInfo } = useContext(AuthContext);
  const { customColor } = useUserLogin();
  const [rows, setRows] = useState<any[]>([]);
  const [isAdding, setIsAdding] = useState(false);
  const [questions, setQuestions] = useState<SecurityQuestionRequestArray>([]);
  const [isQuestionRequired, setIsQuestionRequired] = useState(false);
  const [isAnswerRequired, setIsAnswerRequired] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [currentQuestions, setCurrentQuestions] =
    useState<SecurityQuestionRequestArray | null>(null);
  const themeBackground = userInfo?.theme === "DARK" ? "#24292e" : "";
  const themeTextColor = userInfo?.theme === "DARK" ? "#fafbfc" : "";
  const [newRowId, setNewRowId] = useState<number | null>(null);
  const [isEditHovered, setIsEditHovered] = useState<number | null>(null);

  const [isDeleteHovered, setIsDeleteHovered] = useState<number | null>(null);
  const [isHovered, setIsHovered] = useState(false);
  const [buttonHoverStates, setButtonHoverStates] = useState<ButtonHoverStates>(
    {}
  );
  const handleMouseEnter = (rowId: string, buttonType: "edit" | "delete") => {
    setButtonHoverStates((prev) => ({
      ...prev,
      [rowId]: {
        ...prev[rowId],
        [buttonType]: true,
      },
    }));
  };

  const handleMouseLeave = (rowId: string, buttonType: "edit" | "delete") => {
    setButtonHoverStates((prev) => ({
      ...prev,
      [rowId]: {
        ...prev[rowId],
        [buttonType]: false,
      },
    }));
  };
  useEffect(() => {
    fetchQuestions();
    fetchCurrentUserQuestions();
  }, []);

  const fetchQuestions = async () => {
    try {
      const response: any = await QuestionList(username);
      if (response.respCode === 2000) {
        setQuestions(response.questionInfo);
      }
    } catch (error: any) {
      if (isAxiosError(error)) {
        const code = error.request.status || error.code;
        showConnectionError(
          ALERTMSG.SERVDISRUPTION,
          `(${code})`,
          "error",
          themeBackground,
          customColor,
          themeTextColor
        );
      } else {
        const code = error.response.status || error.code;
        showConnectionError(
          ALERTMSG.UNDHANDLEDERR,
          `${code}`,
          "error",
          themeBackground,
          customColor,
          themeTextColor
        );
      }
    }
  };

  const fetchCurrentUserQuestions = async () => {
    try {
      const response: any = await UserQuestion(username);
      if (response.respCode === 2000) {
        setCurrentQuestions(response.userQuestionInfo);
      }
    } catch (error: any) {
      if (isAxiosError(error)) {
        const code = error.request.status || error.code;
        showConnectionError(
          ALERTMSG.SERVDISRUPTION,
          `(${code})`,
          "error",
          themeBackground,
          customColor,
          themeTextColor
        );
      } else {
        const code = error.response.status || error.code;
        showConnectionError(
          ALERTMSG.UNDHANDLEDERR,
          `${code}`,
          "error",
          themeBackground,
          customColor,
          themeTextColor
        );
      }
    }
  };

  useEffect(() => {
    if (currentQuestions && currentQuestions.length > 0) {
      setRows(
        currentQuestions.map((question) => ({
          id: question.questionId,
          selectedOption: question,
          answer: "",
          isEditing: false,
        }))
      );
    } else if (questions.length > 0) {
      // setRows(
      //   questions.slice(0, 2).map((question) => ({
      //     id: question.questionId,
      //     selectedOption: question,
      //     answer: "",
      //     isEditing: false,
      //   }))
      // );
    }
  }, [currentQuestions, questions]);

  const addRow = (selectedOption: any, answer: string) => {
    if (rows.length < 6) {
      const newRow = {
        id: Date.now(),
        selectedOption: selectedOption || { questionId: null, question: "" },
        answer: answer || "",
        isEditing: true,
        adding: true,
      };
      setRows([...rows, newRow]);
      setNewRowId(newRow.id);
      setIsAdding(true);
      setIsHovered(false);
    }
  };

  const handleOptionChange = (id: number, selectedId: number) => {
    const selectedQuestion = questions.find(
      (q) => q.questionFixId === selectedId
    );

    if (selectedQuestion) {
      setRows((prevRows) =>
        prevRows.map((row) =>
          row.id === id ? { ...row, selectedOption: selectedQuestion } : row
        )
      );
      setIsQuestionRequired(false);
    }
  };

  const handleAnswerChange = (id: number, value: string) => {
    setRows((prevRows) =>
      prevRows.map((row) => (row.id === id ? { ...row, answer: value } : row))
    );
    setIsAnswerRequired(false);
  };

  const saveRow = async (id: number) => {
    const updatedRow = rows.find((row) => row.id === id);
    setIsDone(false);

    if (updatedRow) {
      const { selectedOption, answer } = updatedRow;
      const questionId = selectedOption.questionFixId;

      // Validate details
      if (!questionId || !selectedOption.question) {
        stopLoading();
        setIsQuestionRequired(true);
        // showAlert(
        //   ALERTMSG.OOPS,
        //   "All fields are required.",
        //   "error",
        //   themeBackground,
        //   themeTextColor
        // );
        return;
      }

      if (!answer) {
        stopLoading();
        setIsAnswerRequired(true);
        return;
      }

      //Validate if the question is already exists
      const hasDuplicate = currentQuestions?.some(
        (question) => question.questionFixId === questionId
      );

      if (hasDuplicate) {
        stopLoading();
        showAlert(
          ALERTMSG.OOPS,
          "The question is already exists.",
          "error",
          customColor,
          themeBackground,
          themeTextColor
        );
        return;
      }

      const details: QnARequestArray = [
        {
          questionFixId: questionId,
          answer: answer,
          question: selectedOption.question,
        },
      ];
      generateLoading("Please wait...", themeBackground, themeTextColor);
      const response: any = await AddQnA(username, details);
      if (response.respCode !== 2000) {
        stopLoading();
        showAlert(
          ALERTMSG.SOMEWENTWRONG,
          response.respMsg,
          "error",
          customColor,
          themeBackground,
          themeTextColor
        );
      } else {
        stopLoading();
        setIsDone(true);
        // Update the row to reflect that it has been saved
        await fetchCurrentUserQuestions();
        setRows((prevRows) =>
          prevRows.map((row) => {
            if (row.id === id) {
              return { ...row, isEditing: false, adding: false }; // Set adding to false
            }
            return row;
          })
        );
        // Reset isAdding state and newRowId to prevent adding a new row
        setIsAdding(false);
        setNewRowId(null);
        setIsAdd(false);
      }
    }
  };

  const cancelEdit = (id: number) => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === id ? { ...row, isEditing: false } : row
      )
    );
  };

  const updateRow = (id: number) => {
    setRows((prevRows) =>
      prevRows.map((row) => (row.id === id ? { ...row, isEditing: true } : row))
    );
    setButtonHoverStates({});
  };

  const triggerDeleteRow = async (id: number) => {
    // Prevent deletion if there are only two rows
    if (rows.length <= 2) {
      showAlert(
        ALERTMSG.OOPS,
        "You cannot delete the question; at least two questions must remain!",
        "error",
        customColor,
        themeBackground,
        themeTextColor
      );
      return; // Exit the function
    }

    const rowToDelete = rows.find((row) => row.id === id);
    if (rowToDelete) {
      const { selectedOption } = rowToDelete;
      const questionId = selectedOption.questionId;

      const details: UpdateQnARequestArray = [
        {
          questionId: questionId,
          answer: "DELETED",
          question: selectedOption.question,
          status: "INACTIVE",
        },
      ];

      const confirmed = await confirmationMsg(
        "Delete Security Question?",
        "",
        themeBackground,
        themeTextColor,
        customColor
      );

      if (confirmed) {
        generateLoading("Please wait...", themeBackground, themeTextColor);
        try {
          const response: any = await UpdateQnA(username, details);
          if (response.respCode !== 2000) {
            stopLoading();
            showAlert(
              ALERTMSG.SOMEWENTWRONG,
              response.respMsg,
              "error",
              customColor,
              themeBackground,
              themeTextColor
            );
          } else {
            stopLoading();
            // Delete the row from the state
            setRows((prevRows) => prevRows.filter((row) => row.id !== id));
          }
        } catch (error: any) {
          if (isAxiosError(error)) {
            const code = error.request.status || error.code;
            showConnectionError(
              ALERTMSG.SERVDISRUPTION,
              `(${code})`,
              "error",
              themeBackground,
              customColor,
              themeTextColor
            );
          } else {
            const code = error.response.status || error.code;
            showConnectionError(
              ALERTMSG.UNDHANDLEDERR,
              `${code}`,
              "error",
              themeBackground,
              customColor,
              themeTextColor
            );
          }
        }
      }
    }
  };

  const triggerUpdate = async (id: number, rowz: any) => {
    generateLoading("Please wait...", themeBackground, themeTextColor);
    setTimeout(async () => {
      const updatedRow = rows.find((row) => row.id === id);

      if (updatedRow) {
        const { selectedOption, answer, id } = updatedRow;
        const questionFixId = selectedOption.questionFixId;
        const questionId = id;
        const details: UpdateQnARequestArray = [
          {
            // questionFixId: questionFixId,
            questionId: questionId,
            answer: answer,
            question: selectedOption.question,
            status: "ACTIVE",
          },
        ];
        try {
          const response: any = await UpdateQnA(username, details);
          if (response.respCode !== 2000) {
            stopLoading();
            showAlert(
              ALERTMSG.SOMEWENTWRONG,
              response.respMsg,
              "error",
              customColor,
              themeBackground,
              themeTextColor
            );
          } else {
            stopLoading();
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === id ? { ...row, isEditing: false, answer: "" } : row
              )
            );
          }
        } catch (error: any) {
          if (isAxiosError(error)) {
            const code = error.request.status || error.code;
            showConnectionError(
              ALERTMSG.SERVDISRUPTION,
              `(${code})`,
              "error",
              themeBackground,
              customColor,
              themeTextColor
            );
          } else {
            const code = error.response.status || error.code;
            showConnectionError(
              ALERTMSG.UNDHANDLEDERR,
              `${code}`,
              "error",
              themeBackground,
              customColor,
              themeTextColor
            );
          }
        }

        stopLoading();
      }
    }, 2000);
  };

  const color = userInfo?.theme === "DARK" ? "#fafbfc" : "black";
  const [editStates, setEditStates] = useState(Array(rows.length).fill(false));

  const handleEditToggle = (index: number) => {
    const newEditStates = [...editStates];
    newEditStates[index] = !newEditStates[index];
    setEditStates(newEditStates);
  };

  // Check if any row is in editing state
  const isAnyRowEditing = editStates.some((isEditing) => isEditing);

  return (
    <div className="text-custom-micro">
      {rows.length > 0 ? (
        <table className="min-w-full  mb-4" style={{ color: color }}>
          <thead>
            <tr>
              <th className=" px-4 py-2">Question</th>
              {rows.some((row) => row.isEditing) && (
                <th className=" px-4 py-2"></th>
              )}
              <th className=" px-4 py-2"></th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={row.id}>
                <td
                  className={` px-4 py-2 h-full ${
                    userInfo?.theme === "DARK" ? "text-white" : ""
                  }`}
                >
                  {isAdding && row.isEditing ? (
                    <select
                      value={row.selectedOption.questionId}
                      onChange={(e) =>
                        handleOptionChange(row.id, Number(e.target.value))
                      }
                      className={`flex  rounded-md pl-2 w-full text-black text-custom-micro h-[30px] ${
                        isQuestionRequired
                          ? "border border-red-600"
                          : "border border-gray-300"
                      }`}
                    >
                      <option value="">Select a question</option>
                      {questions.map((question) => (
                        <option
                          key={question.questionFixId}
                          value={question.questionFixId}
                        >
                          {question.question}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <span>{row.selectedOption.question}</span>
                  )}
                </td>

                {row.isEditing ? (
                  <td
                    className={` px-4 py-3.5   ${
                      userInfo?.theme === "DARK" ? "text-white" : ""
                    }`}
                  >
                    <input
                      type="text"
                      value={row.answer}
                      onChange={(e) =>
                        handleAnswerChange(row.id, e.target.value)
                      }
                      placeholder="Answer"
                      className="border border-gray-300 rounded-md w-[150px] text-black text-custom-micro pl-2 h-[30px]"
                    />
                  </td>
                ) : null}
                {!row.adding && (
                  <td className=" px-4 py-3.5 flex space-x-2">
                    {row.isEditing ? (
                      <>
                        <button
                          onClick={() => {
                            triggerUpdate(row.id, rows);
                            // setIsEdit(false);
                            handleEditToggle(index);
                          }}
                          className={`text-[24px] rounded-md px-2 py-1 hover:scale-110 ${
                            userInfo?.theme === "DARK"
                              ? "text-white hover:text-green-500"
                              : "text-green-600 hover:text-green-600 hover:text-shadow-lg hover:text-shadow-red-500/40"
                          }`}
                        >
                          <FaCheckCircle />
                        </button>
                        <button
                          onClick={() => {
                            cancelEdit(row.id);
                            // setIsEdit(false);
                            handleEditToggle(index);
                          }}
                          className={`text-[24px] rounded-md px-2 py-1 hover:scale-110 ${
                            userInfo?.theme === "DARK"
                              ? "text-white hover:text-red-500"
                              : "text-red-600 hover:text-red-500 hover:text-shadow-lg hover:text-shadow-red-500/40"
                          }`}
                        >
                          <FaTimesCircle />
                        </button>
                      </>
                    ) : (
                      <>
                        {isAdd ? (
                          ``
                        ) : (
                          <>
                            {" "}
                            <button
                              onClick={() => {
                                updateRow(row.id);
                                handleEditToggle(index);
                              }}
                              onMouseEnter={() =>
                                handleMouseEnter(row.id, "edit")
                              }
                              onMouseLeave={() =>
                                handleMouseLeave(row.id, "edit")
                              }
                              style={{
                                color: buttonHoverStates[row.id]?.edit
                                  ? customColor
                                  : "",
                              }}
                              className={`lg:text-[22px] md:text-[20px] sm:tex-[18px] text-[16px] rounded-md px-2 py-1 hover:scale-110 ${
                                userInfo?.theme === "DARK"
                                  ? "text-white hover:text-gray-500"
                                  : "text-gray-600 "
                              } ${
                                customColor
                                  ? ``
                                  : `hover:text-red-500 hover:text-shadow-lg hover:text-shadow-red-500/40`
                              }`}
                            >
                              <FaEdit />
                            </button>
                            <button
                              onClick={() => {
                                triggerDeleteRow(row.id);
                              }}
                              onMouseEnter={() =>
                                handleMouseEnter(row.id, "delete")
                              }
                              onMouseLeave={() =>
                                handleMouseLeave(row.id, "delete")
                              }
                              style={{
                                color: buttonHoverStates[row.id]?.delete
                                  ? customColor
                                  : "",
                              }}
                              className={`lg:text-[22px] md:text-[20px] sm:tex-[18px] text-[16px] rounded-md px-2 py-1 hover:scale-110 ${
                                userInfo?.theme === "DARK"
                                  ? "text-white hover:text-gray-500"
                                  : "text-gray-600 "
                              } ${
                                customColor
                                  ? ``
                                  : `hover:text-red-500 hover:text-shadow-lg hover:text-shadow-red-500/40`
                              }`}
                            >
                              <MdDelete />
                            </button>
                          </>
                        )}
                      </>
                    )}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      ) : null}
      <div className="flex justify-end px-4">
        {isAdding ? (
          <>
            <button
              onClick={() => {
                if (newRowId) {
                  saveRow(newRowId);
                  setIsAdd(false);
                }
              }}
              className={`text-[24px] rounded-md px-2 py-1 hover:scale-110 ${
                userInfo?.theme === "DARK"
                  ? "text-white hover:text-green-500"
                  : "text-green-600 hover:text-green-600 hover:text-shadow-lg hover:text-shadow-red-500/40"
              }`}
            >
              <FaCheckCircle />
            </button>
            <button
              onClick={() => {
                setIsAdding(false);
                setRows(rows.slice(0, -1)); // Remove the last added row
                setNewRowId(null);
                setIsQuestionRequired(false);
                setIsAnswerRequired(false);
                setIsAdd(false);
              }}
              className={`text-[24px] rounded-md px-2 py-1 hover:scale-110 ${
                userInfo?.theme === "DARK"
                  ? "text-white hover:text-red-500"
                  : "text-red-600 hover:text-red-500 hover:text-shadow-lg hover:text-shadow-red-500/40"
              }`}
            >
              <FaTimesCircle />
            </button>
          </>
        ) : (
          !isAnyRowEditing &&
          rows.length < 6 && (
            <button
              onClick={() => {
                addRow({ questionId: null, question: "" }, "");
                setIsAdd(true);
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              style={{ color: isHovered ? customColor : "" }}
              className={`text-[28px] rounded-md px-2 py-1 hover:scale-110 ${
                userInfo?.theme === "DARK"
                  ? "text-white hover:text-gray-500"
                  : "text-gray-600 "
              } ${
                customColor
                  ? ``
                  : `hover:text-red-500 hover:text-shadow-lg hover:text-shadow-red-500/40`
              }`}
              disabled={questions.length <= rows.length}
            >
              <IoIosAddCircle />
            </button>
          )
        )}
      </div>
    </div>
  );
};

export default DynamicTable;
